function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME ARCADE (API)

  This file contains functions that other modules may call to get formatted html containing
  game module specific information, concerning: rules / how to play, selectable options,
  abbreviated options to display in game invites, etc.
 
**********************************************************************************/
var SaitoOverlay = require('./../../saito/ui/saito-overlay/saito-overlay');
var GameArcade = /*#__PURE__*/function () {
  function GameArcade() {
    _classCallCheck(this, GameArcade);
  }
  return _createClass(GameArcade, [{
    key: "returnAdvancedOptions",
    value:
    /**
     * Advanced options interface in Arcade creates an overlay with the returned html
     * Can use <div class="overlay-input"></div> to neatly group options
     */
    function returnAdvancedOptions() {
      return '';
    }
  }, {
    key: "returnOptions",
    value: function returnOptions() {
      var html = '';
      if (this.minPlayers === this.maxPlayers) {
        html = "<input type=\"hidden\" class=\"game-wizard-players-select\" name=\"game-wizard-players-select\" value=\"".concat(this.minPlayers, "\">");
        html += this.returnSingularGameOption();
      } else {
        html += "<div class=\"overlay-input\"><select class=\"game-wizard-players-select\" name=\"game-wizard-players-select\">";
        for (var p = this.minPlayers; p <= this.maxPlayers; p++) {
          html += "<option value=\"".concat(p, "\" ").concat(p === this.minPlayers ? 'selected default' : '', ">").concat(p, " player</option>");
        }
        if (this.opengame) {
          html += "<option value=\"open-table\">open table</option>";
        }
        html += "</select></div>";
      }
      return html;
    }

    /**
     * Called when displaying advanced game options, so you can dynamically change the DOM as users select options
     * (i.e. hide/display options that have prerequisites)
     */
  }, {
    key: "attachAdvancedOptionsEventListeners",
    value: function attachAdvancedOptionsEventListeners() {
      var crypto = document.getElementById('crypto');
      var stakeInput = document.getElementById('stake_input');
      if (crypto && stakeInput) {
        crypto.onchange = function () {
          if (crypto.value) {
            stakeInput.style.display = 'block';
          } else {
            stakeInput.style.display = 'none';
          }
        };
      }
      return;
    }

    /**
     * A stub that should be overwritten by the game module to return a formatted HTML (to be inserted into an overlay) description of the game rules
     */
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return '';
    }
  }, {
    key: "returnDefaultGameOptions",
    value: function returnDefaultGameOptions() {
      var playerOptions = this.returnOptions();
      var advancedOptions = this.returnAdvancedOptions();
      var metaOverlay = new SaitoOverlay(this.app, this, false, false);
      metaOverlay.show("<form class=\"default_game_options\">".concat(playerOptions).concat(advancedOptions, "</form>"));
      metaOverlay.hide();
      var options = {
        game: this.name
      };
      document.querySelectorAll('form.default_game_options input, form.default_game_options select').forEach(function (element) {
        if (element.name) {
          if (element.type == 'checkbox') {
            if (element.checked) {
              options[element.name] = 1;
            }
          } else if (element.type == 'radio') {
            if (element.checked) {
              options[element.name] = element.value;
            }
          } else {
            options[element.name] = element.value;
          }
        }
      });
      metaOverlay.remove();
      return options;
    }

    /**
     * Semi-Advanced options interface in Arcade allows 2 player games to elevate a separate option in lieu of # players
     * Should be a <select>
     */
  }, {
    key: "returnSingularGameOption",
    value: function returnSingularGameOption() {
      return '';
    }

    /*
     * A method to filter out some of the game options to clean up the game invite display in the arcade
     * Game invites list options, or rename the options in a more user friendly way
     * See also arcade/lib/arcade-main/templates/arcade-invite.template.js
     */
  }, {
    key: "returnShortGameOptionsArray",
    value: function returnShortGameOptionsArray(options) {
      var sgo = {};
      var crypto = '';
      for (var i in options) {
        if (options[i] !== '') {
          var output_me = 1;
          if (i == 'clock') {
            output_me = 0;
            if (options[i] == 0) {
              sgo[i] = 'unlimited';
            } else {
              sgo[i] = options[i] + ' minutes';
            }
          }
          if (i == 'lightning') {
            output_me = 0;
            if (options[i] != 0) {
              sgo[i] = "+".concat(options[i], " seconds");
            }
          }
          if (i == 'observer' && options[i] != 'enable') {
            output_me = 0;
          }
          if (i == 'league_id') {
            output_me = 0;
          }
          if (i == 'league_name') {
            output_me = 0;
            sgo['league'] = "<span class=\"saito-league\">".concat(options[i], "</span>");
          }
          if (i == 'open-table') {
            output_me = 0;
            sgo['max players'] = options['game-wizard-players-select-max'];
          }
          if (i.includes('game-wizard-players')) {
            output_me = 0;
          }
          if (i == 'game') {
            output_me = 0;
          }
          if (i == 'crypto') {
            output_me = 0;
            crypto = options[i]; //Don't display but save this info
          }
          if (i == 'stake') {
            output_me = 0;
            if (crypto) {
              if (_typeof(options['stake']) === 'object') {
                var min = parseFloat(options.stake.min);
                var max = min;
                for (var q in options.stake) {
                  if (parseFloat(options.stake[q]) > max) {
                    max = parseFloat(options.stake[q]);
                  }
                }
                sgo['stake'] = "".concat(min, " - ").concat(max, " ").concat(crypto);
              } else if (parseFloat(options['stake']) > 0) {
                sgo['stake'] = options['stake'] + ' ' + crypto;
              }
            }
          }
          if (i == 'desired_opponent_publickey') {
            output_me = 0;
            /*sgo['invited player'] = this.app.browser.returnAddressHTML(
            options[i]
            );*/
          }
          if (output_me == 1) {
            sgo[i] = options[i];
          }
        }
      }
      return sgo;
    }

    /*
     * DEPRECATED -- It was a way to reorganize the options read from HTML and better package it,
     * However, the few game modules that implemented it didn't make any meaningful difference, but introduced errors
     * A method for game modules to (optionally) filter the whole list of options to a smaller object.
     * That object gets included in the game data packaged with the transaction to create an invite
     */
  }, {
    key: "returnFormattedGameOptions",
    value: function returnFormattedGameOptions(options) {
      return options;
    }
  }]);
}();
module.exports = GameArcade;